import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@core/services/entities/auth.service';

export const GuestGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const accessToken = authService.currentAccessToken;

  const queryString = state.url.includes('?') ? state.url.split('?')[1] : '';
  const urlParams = new URLSearchParams(queryString);
  const mcpCallback = urlParams.get('mcp_callback');
  const mcpState = urlParams.get('state');

  if (mcpCallback) {
    if (accessToken) {
      const params = new URLSearchParams({ token: accessToken });
      if (mcpState) params.set('state', mcpState);
      window.location.href = `${decodeURIComponent(mcpCallback)}?${params.toString()}`;
      return false;
    }
    return true;
  }

  if (accessToken && (state.url !== '/auth/switch/company' || 'auth/recovery/password')) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
